import * as React from 'react'
import { inject, observer } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExternalDataStore from '../../../Stores/ExternalDataStore'
import NotificationsStore, { NotificationEntity } from '../../../Stores/NotificationsStore'
import ExternalDataCreditInfoItemsView
    from '../../PartialViews/ExternalData/ExternalDataViews/ExternalDataCreditInfoItemsView'

export interface IExternalDataByNamePageProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    externalDataStore: ExternalDataStore
    notificationsStore: NotificationsStore
}

@inject('localizationStore')
@inject('httpActionsService')
@inject('externalDataStore')
@inject('notificationsStore')

@observer
class ExternalDataByNamePage extends React.Component<IExternalDataByNamePageProps> {

    constructor(props: any) {
        super(props)
    }

    componentDidMount() {
        if (this.props['match']!['params']['surname'] && this.props['match']!['params']['name']) {
            this.props.httpActionsService!
                .getExternalDataByName(
                    this.props['match']!['params']['surname'],
                    this.props['match']!['params']['name'])
        } else {
            this.props.notificationsStore
                .addAlert(
                    new NotificationEntity(
                        'danger',
                        this.props.localizationStore!.t('no surname or name in query params!')
                    )
                )
        }
    }

    render() {
        const { externalDataStore, localizationStore } = this.props

        if (externalDataStore!.isError) {
            return (<div>{this.props.localizationStore!.t('No data text')}</div>)
        }

        return (
            <div className="external-data-page">
                {!!externalDataStore!.getData && externalDataStore!.getData!.creditInfoItems.length
                    ? <ExternalDataCreditInfoItemsView
                        creditInfoItems={externalDataStore!.getData!.creditInfoItems}
                        headerText={localizationStore!.t!('Get external data by phone')}
                    />
                    : this.props.localizationStore!.t('No data text')}
            </div>
        )
    }
}

export default withRouter(ExternalDataByNamePage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/ExternalDataPages/ExternalDataByNamePage.tsx